export const BONUS_CLAIM_LIST = 'BONUS_CLAIM_LIST';